__turbopack_context__.v({
  "banner": "index-module-scss-module__wCHX3a__banner",
  "banner__button": "index-module-scss-module__wCHX3a__banner__button",
  "banner__image": "index-module-scss-module__wCHX3a__banner__image",
  "banner__sub": "index-module-scss-module__wCHX3a__banner__sub",
  "banner__title": "index-module-scss-module__wCHX3a__banner__title",
  "body": "index-module-scss-module__wCHX3a__body",
  "closeButton": "index-module-scss-module__wCHX3a__closeButton",
  "counterBadge": "index-module-scss-module__wCHX3a__counterBadge",
  "counterText": "index-module-scss-module__wCHX3a__counterText",
  "divider": "index-module-scss-module__wCHX3a__divider",
  "icon": "index-module-scss-module__wCHX3a__icon",
  "item": "index-module-scss-module__wCHX3a__item",
  "listItem": "index-module-scss-module__wCHX3a__listItem",
  "message": "index-module-scss-module__wCHX3a__message",
  "messageWrapper": "index-module-scss-module__wCHX3a__messageWrapper",
  "messages": "index-module-scss-module__wCHX3a__messages",
  "name": "index-module-scss-module__wCHX3a__name",
  "notificationList": "index-module-scss-module__wCHX3a__notificationList",
  "readIcon": "index-module-scss-module__wCHX3a__readIcon",
  "root": "index-module-scss-module__wCHX3a__root",
  "text": "index-module-scss-module__wCHX3a__text",
});
